<template>
  <div>
    <VCardTitle :class="textClass" class="dialog-header justify-start">
      {{ title }}
      <VBtn
        class="v-btn-close"
        icon
        small
        absolute
        top
        right
        @click="$emit('close')"
      >
        <IconClose />
      </VBtn>
    </VCardTitle>
  </div>
</template>

<script>
import IconClose from './SvgIcons/Close.vue';

export default {
  name: 'DialogHeader',
  components: { IconClose },
  props: {
    title: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: 'black--text',
    },
  },
};
</script>

<style scoped lang="scss">
.v-btn-close {
  margin-top: -7px;
  margin-right: -7px;
}
.dialog-header {
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  color: #212121 !important;
  padding: 20px 20px 0
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .dialog-header {
    font-weight: 400;
    font-size: 24px;
    line-height: 29px;
  }
}
</style>
